import React, { useState, JSX } from 'react';
import { Button } from 'reactstrap';
import { sanitize } from '@ibe/services';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  title: string | undefined;
  text: string | undefined;
}

function PackageImportantInfoPanel(props: Props): JSX.Element {
  const { title } = props;
  const { text } = props;

  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <div className="shadow">
        <div
          className={`d-flex justify-content-between align-items-center ${
            isExpanded && ' border-bottom'
          }`}
        >
          <h5 className="pl-2 mb-0">{title}</h5>
          <Button
            type="button"
            color="primary"
            onClick={(): void => {
              setIsExpanded(!isExpanded);
            }}
          >
            {isExpanded ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus} />}
          </Button>
        </div>
        {isExpanded && text && (
          <div className="p-2" dangerouslySetInnerHTML={{ __html: sanitize(text) }} />
        )}
      </div>
    </>
  );
}

export default PackageImportantInfoPanel;
